const MILLISECONDS_PER_SECOND = 1000;

export const formatUsd = (value: number | null): string => {
    if (value === null) {
        return "—";
    }

    return `$${value.toFixed(value > 0 && value < 0.01 ? 4 : 2)}`;
};

export const formatCount = (value: number): string =>
    new Intl.NumberFormat().format(value);

export const formatDuration = (milliseconds: number | null): string => {
    if (milliseconds === null) {
        return "—";
    }

    if (milliseconds < MILLISECONDS_PER_SECOND) {
        return `${formatCount(milliseconds)} ms`;
    }

    return `${(milliseconds / MILLISECONDS_PER_SECOND).toFixed(1)} s`;
};
